<template>
  <div class="l-footer" id="footer">
    <div class="l-footer_ctn maintain">
      <a href="https://riche-partners.com" :class="['link_blue', { 'f-top_page': isTopPage }]"> 運営会社 </a>
    </div>
    <!-- <div class="l-footer_ctn">
      <router-link
        :class="['link_blue', { 'f-top_page': isTopPage }]"
        :to="{ name: 'OperatingCompany' }"
      >
        運営会社
      </router-link>
      <router-link
        class="link_blue"
        :to="{ name: 'Privacy Policy' }"
        v-if="!isTopPage"
        >個人情報保護</router-link
      >
      <router-link
        class="link_blue"
        :to="{ name: 'Term Of Service' }"
        v-if="!isTopPage"
        >利用規約</router-link
      >
      <router-link
        class="link_blue"
        :to="{ name: 'Site Map' }"
        v-if="!isTopPage"
        >サイトマップ</router-link
      >
      <router-link
        class="link_blue"
        :to="{ name: 'FAQ List' }"
        v-if="!isTopPage"
        >FAQ</router-link
      >
      <router-link class="link_blue" :to="{ name: 'Inquiry' }" v-if="!isTopPage"
        >お問い合わせ</router-link
      >
    </div> -->
    <div class="l-footer_text">
      <span
        >Ｒ２　事業再構築　機ー１　※事業再構築補助金事業以外での使用禁止</span
      >
    </div>
    <div class="l-footer_copyright">
      <span>Copyright© RICHE PARTNERS Co., Ltd. All Rights Reserved.</span>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    isTopPage() {
      if (process.env.VUE_APP_COLLECT_MODE) {
        return true;
      }
      return false;
    },
  },
};
</script>
